define('bindingHandlers/pollingValue',[
    'jquery',
    'lib/knockout'
], function ($, ko) {
    'use strict';

    /**
     * Bug Fix for UI-389
     * https://inindca.atlassian.net/browse/UI-389
     *
     * Autofill and managed password features in browsers can change inputs without knockout knowing about the change.
     * The reason is that those browser features sometimes do not fire events.
     * This custom binding fixes this bug.
     */
    
    /**
     * This function polls the input and sets the observable.
     * @param  {object} The DOM element involved in this binding
     * @param  {function} Function that gets the current model property that is involved in this binding
     */
    var pollTheInput = function (element, valueAccessor) {

        var timerID = setInterval(function () {
            
            var observable = valueAccessor();
            var value = element.value;
            // set the observable to the new value
            observable(value);

        }, 250);

        return timerID;
    };

    /**
     * Creating a wrapper for the value binding
     * @type {Object}
     */
    ko.bindingHandlers.pollingValue = {
        
        /**
         * On initialize, poll the input in the case that autofill set the element value
         * and knockout did not pick up the change because no event was fired.
         */
        init: function (element, valueAccessor, allBindings, bindingContext) {
            var timerID = pollTheInput(element, valueAccessor);
            ko.bindingHandlers.value.init(element, valueAccessor, allBindings, bindingContext);

            // clear the interval on the domNodeDisposal callback
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                clearInterval(timerID);
            });
        },
        update: function(element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            // don't re-set the value of the element if the element's value changing
            // is what caused the value of the observable to change
            var oldValue = $(element).val();
            if(value !== oldValue) {
                $(element).val(value);
            }
        }

    };
});

